sn-how-to-decoration-type-1 {
  display: block;
  position: relative;

  > [slot='item'] {
    display: none;
  }

  // Illustration & media styles (legacy global classes used by renderScreen01–06) are
  // scoped under the host element so they no longer leak into global/critical CSS and
  // defer like every other component. Unused legacy blocks (slick slider, navigation-
  // options, accordion, sign-explanation, how-to-sign-nav, animation utilities/keyframes)
  // were removed — the current render does not use them.
  .page-section__column--media {
    position: relative;
    width: 277px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 32px;
    min-height: 236px;
  
    @include above(375px) {
      width: 331px;
    }
  
    @include above(640px) {
      width: 512px;
      min-height: 442px;
    }
  
    @include above(960px) {
      flex-shrink: 0;
      width: 420px;
      min-height: inherit;
      margin: 0;
    }
  
    @include above(1280px) {
      width: 560px;
    }
  }
  
  .sign-illustration {
    position: relative;
    height: 100%;
    min-height: 236px;
  
    @include above(640px) {
      min-height: 442px;
    }
  
    @include above(960px) {
      min-height: 300px;
    }
  
    @include above(1280px) {
      min-height: 442px;
    }
  
    .sign-illustration__image-primary,
    .sign-illustration__image-secondary {
      position: absolute;
    }
  
    &.sign-illustration--screen01 {
      .sign-illustration__square {
        background-color: #94ead9;
      }
  
      .sign-illustration__image-primary {
        top: 16px;
        left: 0;
        animation-delay: 0.3s;
  
        @include above(375px) {
          left: 21px;
        }
  
        @include above(640px) {
          left: -7px;
          top: 31px;
        }
  
        @include above(960px) {
          top: 31px;
          left: 24px;
        }
  
        @include above(1280px) {
          left: auto;
        }
  
        img {
          width: 100%;
          height: auto;
          box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(375px) {
            @include size(280px, 186px);
          }
  
          @include above(640px) {
            @include size(525px, 350px);
  
            border-radius: 8px;
            box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
          }
  
          @include above(960px) {
            @include size(378px, 252px);
          }
  
          @include above(1280px) {
            @include size(525px, 350px);
          }
        }
      }
  
      .sign-illustration__image-secondary {
        top: 119px;
        right: -6px;
        animation-delay: 0.7s;
  
        @include above(375px) {
          right: 20px;
        }
  
        @include above(640px) {
          top: 223px;
          right: -27px;
        }
  
        @include above(960px) {
          right: 0;
          top: 180px;
        }
  
        @include above(1280px) {
          top: 223px;
        }
  
        img {
          @include size(170px, 116px);
  
          box-shadow: 0 4px 21px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(640px) {
            @include size(320px, 220px);
  
            border-radius: 8px;
            box-shadow: 0 8px 40px rgb(0 0 0 / 10%);
          }
  
          @include above(960px) {
            @include size(240px, 165px);
          }
  
          @include above(1280px) {
            @include size(320px, 220px);
          }
        }
      }
    }
  
    &.sign-illustration--screen02 {
      .sign-illustration__square {
        background-color: #ffe289;
      }
  
      .sign-illustration__image-primary {
        top: 16px;
        left: 0;
        animation-delay: 0.3s;
  
        @include above(375px) {
          left: 21px;
        }
  
        @include above(640px) {
          left: -7px;
          top: 31px;
        }
  
        @include above(960px) {
          top: 31px;
          left: 24px;
        }
  
        @include above(1280px) {
          left: auto;
        }
  
        img {
          width: 100%;
          height: auto;
          box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(375px) {
            @include size(280px, 186px);
          }
  
          @include above(640px) {
            @include size(525px, 350px);
  
            border-radius: 8px;
            box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
          }
  
          @include above(960px) {
            @include size(378px, 252px);
          }
  
          @include above(1280px) {
            @include size(525px, 350px);
          }
        }
      }
  
      .sign-illustration__image-secondary {
        top: 110px;
        right: -6px;
        animation-delay: 0.7s;
  
        @include above(375px) {
          right: 10px;
        }
  
        @include above(640px) {
          top: 232px;
          right: -27px;
        }
  
        @include above(960px) {
          right: 0;
          top: 180px;
        }
  
        @include above(1280px) {
          top: 232px;
        }
  
        img {
          @include size(150px, 125px);
  
          filter: drop-shadow(0 4px 21px rgb(0 0 0 / 10%));
          border-radius: 4px;
  
          @include above(640px) {
            @include size(255px, 212px);
  
            border-radius: 8px;
            filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          }
  
          @include above(960px) {
            @include size(200px, 166px);
          }
  
          @include above(1280px) {
            @include size(255px, 212px);
          }
        }
      }
    }
  
    &.sign-illustration--screen03 {
      .sign-illustration__square {
        background-color: #ffeede;
      }
  
      .sign-illustration__image-primary {
        top: 16px;
        left: 0;
        animation-delay: 0.3s;
  
        @include above(375px) {
          left: 21px;
        }
  
        @include above(640px) {
          left: -7px;
        }
  
        @include above(960px) {
          top: 31px;
          left: 24px;
        }
  
        @include above(1280px) {
          left: auto;
        }
  
        img {
          width: 100%;
          height: auto;
          box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(375px) {
            @include size(280px, 186px);
          }
  
          @include above(640px) {
            @include size(525px, 350px);
  
            border-radius: 8px;
            box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
          }
  
          @include above(960px) {
            @include size(378px, 252px);
          }
  
          @include above(1280px) {
            @include size(525px, 350px);
          }
        }
      }
  
      .sign-illustration__image-secondary {
        top: 110px;
        right: -6px;
        animation-delay: 0.7s;
  
        @include above(375px) {
          right: 10px;
        }
  
        @include above(640px) {
          top: 294px;
          right: -27px;
        }
  
        @include above(960px) {
          right: 0;
          top: 180px;
        }
  
        @include above(1280px) {
          top: 294px;
        }
  
        img {
          @include size(122px, 123px);
  
          box-shadow: 0 4px 21px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(640px) {
            @include size(150px, 150px);
  
            border-radius: 8px;
            filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          }
        }
      }
  
      .sign-illustration__button {
        position: absolute;
  
        @include size(88px, 30px);
  
        top: 126px;
        left: -10px;
        animation-delay: 0.9s;
  
        @include above(375px) {
          left: 2px;
        }
  
        @include above(640px) {
          top: 241px;
  
          @include size(156px, 54px);
  
          border-radius: 8px;
          filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          left: -32px;
        }
  
        @include above(960px) {
          top: 182px;
          left: 0;
        }
  
        @include above(1280px) {
          top: 241px;
          left: -52px;
        }
  
        img {
          max-width: 100%;
        }
      }
    }
  
    &.sign-illustration--screen04 {
      .sign-illustration__square {
        background-color: #f9d5df;
      }
  
      .sign-illustration__image-primary {
        z-index: 1;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        top: -6px;
  
        @include size(109px, 229px);
  
        animation-delay: 0.3s;
  
        @include above(640px) {
          @include size(210px, 442px);
        }
  
        @include above(960px) {
          left: 65px;
        }
  
        @include above(1280px) {
          left: 165px;
          margin-left: 0;
          margin-right: 0;
        }
  
        img {
          max-width: 100%;
  
          @include size(109px, 229px);
  
          box-shadow: 0 4px 21px rgb(0 0 0 / 10%);
          border-radius: 8px;
  
          @include above(640px) {
            @include size(210px, 442px);
  
            box-shadow: 0 8px 40px rgb(0 0 0 / 10%);
          }
  
          @include above(960px) {
            @include size(160px, 337px);
          }
  
          @include above(1280px) {
            @include size(210px, 442px);
          }
        }
      }
  
      .sign-illustration__image-secondary {
        top: 43px;
        left: 40px;
        animation-delay: 0.7s;
  
        @include above(640px) {
          top: 85px;
          left: 51px;
        }
  
        @include above(960px) {
          top: 53px;
        }
  
        @include above(1280px) {
          top: 85px;
          left: 33px;
        }
  
        img {
          @include size(100px, 134px);
  
          box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(640px) {
            @include size(164px, 220px);
  
            box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
          }
        }
      }
  
      .sign-illustration__image-tertiary {
        position: absolute;
        top: 43px;
        right: 40px;
        animation-delay: 0.7s;
  
        @include above(640px) {
          top: 85px;
          right: 51px;
        }
  
        @include above(960px) {
          top: 53px;
        }
  
        @include above(1280px) {
          top: 85px;
          right: 51px;
        }
  
        img {
          @include size(100px, 134px);
  
          box-shadow: 0 3px 11px rgb(0 0 0 / 10%);
          border-radius: 4px;
  
          @include above(640px) {
            @include size(164px, 220px);
  
            box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
          }
        }
      }
    }
  
    &.sign-illustration--screen05 {
      .sign-illustration__square {
        background-color: #d7e7fd;
      }
  
      .sign-illustration__image-primary {
        top: -29px;
        left: 16px;
        animation-delay: 0.3s;
  
        @include above(375px) {
          left: 42px;
        }
  
        @include above(640px) {
          top: -46px;
          left: 24px;
        }
  
        @include above(1280px) {
          left: 45px;
        }
  
        img {
          @include size(140px, 228px);
  
          @include above(640px) {
            @include size(262px, 427px);
  
            filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          }
  
          @include above(960px) {
            @include size(202px, 329px);
          }
  
          @include above(1280px) {
            @include size(262px, 427px);
          }
        }
      }
  
      .sign-illustration__image-secondary {
        top: 30px;
        right: 16px;
        animation-delay: 0.7s;
  
        @include above(375px) {
          right: 42px;
        }
  
        @include above(640px) {
          top: 49px;
          right: 24px;
        }
  
        @include above(1280px) {
          right: 57px;
        }
  
        img {
          @include size(140px, 228px);
  
          @include above(640px) {
            @include size(262px, 427px);
  
            filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          }
  
          @include above(960px) {
            @include size(202px, 329px);
          }
  
          @include above(1280px) {
            @include size(262px, 427px);
          }
        }
      }
    }
  
    &.sign-illustration--screen06 {
      .sign-illustration__square {
        background-color: #eee8fe;
      }
  
      .sign-illustration__image-primary {
        top: -30px;
        left: 16px;
        animation-delay: 0.3s;
  
        @include above(375px) {
          left: 42px;
        }
  
        @include above(640px) {
          top: -54px;
          left: 24px;
        }
  
        @include above(1280px) {
          left: 45px;
          top: -46px;
        }
  
        img {
          @include size(140px, 247px);
  
          @include above(640px) {
            @include size(261px, 460px);
  
            filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          }
  
          @include above(960px) {
            @include size(202px, 329px);
          }
  
          @include above(1280px) {
            @include size(261px, 460px);
          }
        }
      }
  
      .sign-illustration__image-secondary {
        top: 20px;
        right: 16px;
        animation-delay: 0.7s;
  
        @include above(375px) {
          top: 25px;
          right: 42px;
        }
  
        @include above(640px) {
          top: 24px;
          right: 24px;
        }
  
        @include above(1280px) {
          right: 57px;
        }
  
        img {
          @include size(140px, 247px);
  
          @include above(640px) {
            @include size(261px, 460px);
  
            filter: drop-shadow(0 8px 40px rgb(0 0 0 / 10%));
          }
  
          @include above(960px) {
            @include size(202px, 329px);
          }
  
          @include above(1280px) {
            @include size(261px, 460px);
          }
        }
      }
    }
  }
  
  .sign-illustration__square {
    @include size(228px, 220px);
  
    border-radius: 4px;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
  
    @include above(640px) {
      @include size(426px, 414px);
  
      border-radius: 8px;
    }
  
    @include above(960px) {
      @include size(326px, 317px);
    }
  
    @include above(1280px) {
      @include size(426px, 414px);
  
      left: -22px;
    }
  }
}

.sn-how-to-decoration-type-1 {
  &__intro {
    .me-heading {
      margin-bottom: var(--spacing-lg);
    }

    .me-text {
      @include text-style('md', 'md');

      @include desktop {
        @include text-style('lg', 'md');

        max-width: 70%;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  &__slide {
    align-items: center;
  }

  &__media {
    min-height: 236px;

    @include above(640px) {
      min-height: 442px;
    }

    @include above(960px) {
      min-height: 300px;
    }

    @include above(1280px) {
      min-height: 442px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__heading {
    margin-bottom: var(--spacing-lg);

    @include desktop {
      margin-bottom: var(--spacing-xl);
    }
  }

  &__text {
    p {
      margin: 0;
    }
  }

  &__navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-lg);
    margin-top: var(--spacing-2xl);

    @include desktop {
      margin-top: var(--spacing-3xl);
    }
  }

  &__dots {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-start;
    gap: 0;
  }

  &__dot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;

    &::before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: var(--color-neutral-neutral);
      transition:
        background-color 0.2s ease,
        transform 0.2s ease;
    }

    &:hover::before,
    &--active::before {
      background-color: var(--color-neutral-black);
      transform: scale(1.2);
    }

    &:focus-visible {
      outline: 2px solid var(--color-neutral-black);
      outline-offset: 2px;
    }
  }

  &__arrows {
    display: flex;
    gap: var(--spacing-sm);
  }

  &__arrow {
    .me-button {
      min-width: 40px;
      min-height: 40px;
      border-radius: 50%;

      &::after {
        border-radius: 50%;
      }

      &:focus,
      &:focus-visible {
        &::after {
          inset: -4px;
          border-radius: 50%;
        }
      }
    }
  }
}
